<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Límites de inflamabilidad</h1>
                <h2 class="animated bounceIn dura-1">Alarmas del equipo</h2>
                <p class="animated fadeIn dura-2">Según la alarma que se active en el equipo, es necesario implementar las siguientes medidas:</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center pantalla">
                <svgmod2 class="animated fadeIn dura-3"></svgmod2>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center mobile">
                <img class="animated fadeIn dura-3" src="@/assets/unidad1/pantalla-6-1.png" alt="celularMobile">
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <p class="animated fadeIn dura-4">La siguiente tabla muestra la comparación entre las densidades de diferentes sustancias y también su límite de explosividad (LEL y UEL).</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <h2 class="animated bounceIn dura-5">Tabla 1: Densidad y límite de explosividad de diferentes sustancias.</h2>
                <svgmod4 class="pantalla animated fadeIn dura-5"></svgmod4>
                <div class="tabla mobile">
                    <svgmod4 class="tabla-mobile animated fadeIn dura-5"></svgmod4>
                </div>
            </v-flex>
            <scrolldown-app></scrolldown-app>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <img class="animated fadeIn dura-3" src="@/assets/unidad1/pantalla-5-1.png" height="390" alt="celularMobile">
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <p class="animated fadeIn dura-4">Las alarmas de los equipos están configuradas en 10% LEL / alarma Baja y 20% de LEL / alarma Alta.</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <p class="animated fadeIn dura-6 FontBase-SemiBoldItalic tituloUnidad">Haz clic en cada ícono para ampliar la información.</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center animated fadeIn dura-7">
                <svgmod1></svgmod1>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <p class="animated fadeIn dura-9">Puedes consultar más información en la página de los Centros de Control y Prevención de Enfermedades
                    <a href="http://www.cdc.gov/" target="_blank">http://www.cdc.gov/</a>
                </p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <h2 class="animated bounceIn dura-10">Tabla 2: Valores de referencia para algunos compuestos comunes en Ecopetrol S. A.</h2>
                    <svgmod5 class="pantalla animated fadeIn dura-5"></svgmod5>
                <div class="tabla mobile">
                    <svgmod5 class="tabla-mobile animated fadeIn dura-5"></svgmod5>
                </div>
               <p><i>Consulta publicación anual de la ACGIH (TWA) y NIOSH (IDLH) - límites vigentes de sustancias peligrosas en la atmosfera.</i></p>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgmod1 from "./svg/mod5-1"
import svgmod2 from "./svg/mod5-2"
import svgmod3 from "./svg/mod5-3"
import svgmod4 from "./svg/mod5-4"
import svgmod5 from "./svg/mod5-5"
export default {
    components: {
        svgmod1,
        svgmod2,
        svgmod3,
        svgmod4,
        svgmod5,
    },
    mixins: [nextConditions],
    data() {
        return {}
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit('nextShow', false)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.tabla {
    overflow: scroll;
    .tabla-mobile {
        width: 200%;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }
    @media screen and (max-width: 600px) {
        display: block;
    }
}
</style>